import { CloseIcon } from 'assets/icons';
import { Button } from 'components';
import { Globals } from 'utils';
import { PlansService } from 'services';

interface ModalEnableDoctorProps {
  plan?: any
  onClose: (reload?: boolean) => void
}

export const ModalEnablePlan = ({ plan, onClose }: ModalEnableDoctorProps) => {

  const onSubmit = async () => {
    try {
      await PlansService.enable({ id: plan.id });
      onClose(true);
      Globals.showSuccess('Plan activado');

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  return (
    <div>
      <header>
        <p className="title">Confirmar</p>
        <button className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <p className="message">¿Está seguro de que desea activar este plan?</p>
      <div className="actions">
        <Button onClick={() => onClose()} clear>Cancelar</Button>
        <Button onClick={onSubmit}>Aceptar</Button>
      </div>
    </div>
  );
}

interface ModalDisableDoctorProps {
  plan?: any
  onClose: (reload?: boolean) => void
}

export const ModalDisablePlan = ({ plan, onClose }: ModalDisableDoctorProps) => {

  const onSubmit = async () => {
    try {
      await PlansService.disable({ id: plan.id });
      onClose(true);
      Globals.showSuccess('Plan suspendido');

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  return (
    <div>
      <header>
        <p className="title">Confirmar</p>
        <button className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <p className="message">¿Está seguro de que desea suspender este plan?</p>
      <div className="actions">
        <Button onClick={() => onClose()} clear>Cancelar</Button>
        <Button onClick={onSubmit}>Aceptar</Button>
      </div>
    </div>
  );
}

interface ModalDeletePatientProps {
  plan?: any
  onClose: (reload?: boolean) => void
}

export const ModalDeletePlan = ({ plan, onClose }: ModalDeletePatientProps) => {

  const onSubmit = async () => {
    try {
      await PlansService.delete({ id: plan.id });
      onClose(true);
      Globals.showSuccess('Plan eliminado');

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  return (
    <div>
      <header>
        <p className="title">Confirmar</p>
        <button className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <p className="message">¿Está seguro de que desea eliminar este plan?</p>
      <div className="actions">
        <Button onClick={() => onClose()} clear>Cancelar</Button>
        <Button onClick={onSubmit}>Aceptar</Button>
      </div>
    </div>
  );
}
